// initial state
const state = {
  currency: 'USD',
  exchangerate: 1
}

// mutations
const mutations = {
  currencyChange (state, currency) {
    state.currency = currency
  },
  exchangerateChange (state, exchangerate) {
    state.exchangerate = exchangerate
  }
}

export default {
  state,
  mutations
}
